<!-- @format -->

<template>
  <div>
    <div class="ui attached message">
      <div class="content" v-if="riskProfile">
        <strong>Goal's Risk Profile</strong>
      </div>
    </div>
    <div class="ui attached segment">
      <div class="ui">
        <div class="ui">
          <v-select
            label="riskProfileName"
            disabled
            @input="handleRiskChanged"
            v-model="riskProfile"
            :options="riskProfiles"
          >
            <template v-slot:option="option">{{
              option.riskProfileName
            }}</template>
          </v-select>
        </div>
      </div>
    </div>

    <div class="ui attached message">
      <div class="content">
        <strong>Portfolios</strong>
      </div>
    </div>
    <div class="ui attached segment">
      <v-select
        label="portfolioName"
        @input="handlePortfolioChange"
        v-model="selectedPortfolio"
        :options="riskPortfolios"
      >
        <template v-slot:option="option">
          <i
            v-if="option.isWithinRiskNumber"
            class="ui success icon thumbs up"
          ></i>
          <i v-else class="ui orange icon warning"></i>
          {{ option.portfolioName }}
        </template>
      </v-select>
    </div>
    <div v-if="selectedPortfolio">
      <div
        v-if="
          selectedPortfolio.riskProfile.id !=
            goalRiskProfile.getGoalRiskProfileResponse.riskProfileObject.id
        "
        class="ui small bottom red attached message"
      >
        <div class="content">
          <p>
            <i class="ui warning icon"></i>
            This portfolio's risk profile may not be ideally suited to the
            goal's risk profile. Please provide reason for selecting portfolio.
          </p>
          <div class="ui form">
            <div class="field">
              <label>Reason</label>

              <textarea
                v-if="goalRiskProfile"
                v-on:focus="handleReasonChanged"
                v-model="goalRiskProfile.reasonForSelectingPortfolio"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="ui bottom success attached message">
        <div class="content">
          <p>
            <i class="ui thumbs up icon"></i>
            The
            <strong>{{ selectedPortfolio.portfolioName }}</strong> portfolio is
            ideally suited given the goal's risk profile.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";

import { getPortfoliosGivenRisk, getRiskProfiles } from "@/gateway";
export default {
  name: "Testing",
  components: { vSelect, VueSlider },
  props: [
    "riskProfile",
    "selectedPortfolio",
    "riskPortfolios",
    "accounts",
    "goalRiskProfile",
  ],
  data() {
    return { riskProfiles: null };
  },
  watch: {
    selectedPortfolio(newVal) {
      console.log("watching....", newVal);
      if (
        newVal.riskProfile.id ==
        this.goalRiskProfile.getGoalRiskProfileResponse.riskProfileObject.id
      ) {
        this.goalRiskProfile.reasonForSelectingPortfolio = "";
      }
    },
  },

  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },
    async handlePortfolioChange(event) {
      // console.log("handleportfoliochange", event);
      // ev.target.value;
      //
      // console.log("this.accounts", this.accounts);

      // console.log(
      //   " this.accounts[0].portfolios[0].portfolio",
      //     this.accounts[0].portfolios[0].portfolio
      //  );
      this.accounts[0].portfolios[0].portfolio.customPortfolioId =
        event.customPortfolioId;
      this.accounts[0].portfolios[0].portfolio.portfolioId = event.portfolioId;
      this.accounts[0].portfolios[0].portfolio.targetTic = event.targetTic;
      this.tic = event.targetTic;
      this.accounts[0].portfolios[0].portfolio.portfolioName =
        event.portfolioName;
      this.accounts[0].portfolios[0].portfolio.expectedReturn =
        event.expectedReturn;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.localCash =
        event.localCash;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.localBonds =
        event.localBonds;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.localEquity =
        event.localEquity;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.localProperty =
        event.localProperty;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignCash =
        event.foreignCash;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignBonds =
        event.foreignBonds;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignEquity =
        event.foreignEquity;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignProperty =
        event.foreignProperty;

      // offshore
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalCash =
        event.globalCash;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalBonds =
        event.globalBonds;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalInvestmentGrade =
        event.globalInvestmentGrade;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalHighYield =
        event.globalHighYield;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketBonds =
        event.globalEmergingMarketBonds;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.africaEuroBondsExSouthAfrica =
        event.africaEuroBondsExSouthAfrica;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalProperty =
        event.globalProperty;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquity =
        event.globalEquity;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEquitySmallCapStocks =
        event.globalEquitySmallCapStocks;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalEmergingMarketEquity =
        event.globalEmergingMarketEquity;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalHedgeFunds =
        event.globalHedgeFunds;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.listedPrivateEquity =
        event.listedPrivateEquity;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.listedInfrastructure =
        event.listedInfrastructure;
      this.accounts[0].portfolios[0].portfolio.assetAllocation.globalIncomeOpportunities =
        event.globalIncomeOpportunities;

      this.accounts[0].portfolios[0].portfolio.assetAllocation.localCredit =
        event.localCredit;

      this.accounts[0].portfolios[0].portfolio.assetAllocation.localInfrastructure =
        event.localInfrastructure;
      this.$emit("handleSelected", {
        //  riskProfile: this.riskProfile,
        //  goalRiskProfile: this.goalRiskProfile,
        selectedPortfolio: this.selectedPortfolio,
        riskPortfolios: this.riskPortfolios,
        accounts: this.accounts,
      });

      // console.log("this.accounts", this.accounts);
      //this.updateProjection();
      //  this.accounts[0].
      /* this.accounts[this.selected.accountId - 1] = changePortfolioInAccount(
        account,
        index,
        portfolioId,
        weight
      );
      this.selected = this.accounts[this.selected.accountId - 1];*/
    },
    async handleReasonChanged(event) {
      console.log("reason changed");
      this.$emit("handleReasonChanged", {
        //  riskProfile: this.riskProfile,
        //  goalRiskProfile: this.goalRiskProfile,
      });
    },
    async handleSelected(selected) {
      if (this.riskProfile) {
        var response = await getPortfoliosGivenRisk({
          riskProfileId: this.riskProfile.id, // riskNumber: Math.min(this.riskCapacity, this.riskTolerance),
        });
        if (response) {
          this.riskPortfolios = response.result;

          if (!this.selectedPortfolio) {
            this.selectedPortfolio = _.filter(this.riskPortfolios, {
              isWithinRiskNumber: true,
            })[0];
          } else {
            this.selectedPortfolio = _.filter(this.riskPortfolios, {
              id: this.selectedPortfolio.id,
            })[0];
          }

          this.$emit("handleSelected", {
            riskProfile: this.riskProfile,
            selectedPortfolio: this.selectedPortfolio,
            riskPortfolios: this.riskPortfolios,
            accounts: this.accounts,
          });
        }
      }
    },
    async handleRiskChanged(selected) {
      this.riskProfile = selected;
      if (this.riskProfile) {
        var response = await getPortfoliosGivenRisk({
          riskProfileId: this.riskProfile.id, // riskNumber: Math.min(this.riskCapacity, this.riskTolerance),
        });
        if (response) {
          this.riskPortfolios = response.result;
          this.$emit("handleSelected", {
            riskProfile: this.riskProfile,
            goalRiskProfile: this.goalRiskProfile,
            selectedPortfolio: this.selectedPortfolio,
            riskPortfolios: this.riskPortfolios,
            accounts: this.accounts,
          });
        }
      }
    },
    updateProjection() {
      this.$emit("updateProjection");
    },

    async init() {
      const response = await getRiskProfiles();

      this.riskProfiles = response.result;
      // this.riskProfile = this.riskProfiles[0];
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
